$(function(){
  
  
  // CART FORM VALIDATION

  var cf = $('input[name="attributes[codice_fiscale]"]');
  var company = $('input[name="attributes[ragione_sociale]"]');
  var cf_company = $('input[name="attributes[codice_fiscale_azienda]"]');
  var piva = $('input[name="attributes[partita_iva]"]');
  var pec = $('input[name="attributes[pec]"]');
  var sdi = $('input[name="attributes[sdi]"]');
  
  var customMessage = $('.custom-message');
  
  $(document).on('change', 'input[name="attributes[tipo_utente]"]', function(){
  	var val = $(this).val();
   	setRequiredFields(val);
  });
  
  
 
  $(document).on('click', '#update-cart', function(e){
    var user_type = $('input[name="attributes[tipo_utente]"]:checked').val();
    if(user_type) {
    	$('#collapse-data').prop('checked', true);  
    }
   
  });
  
  $(document).on('submit', 'form#cartform', function(e){
  // $(document).on('click', 'form .btn-checkout', function(e){
    console.log("submit");
     
    var user_type = $('input[name="attributes[tipo_utente]"]:checked').val();
 
    if(user_type == 'Azienda') {
      if (pec.val() == '' && sdi.val() == '') {
        e.preventDefault();
        e.stopPropagation();
      	customMessage.show();
      }
    } else {
    	customMessage.hide();
    }
  });

  
  function setRequiredFields(user_type_value){

    console.log("setRequiredFields", user_type_value);
    
  	 if(user_type_value == 'Privato'){
    	$('.enduser-fields').slideDown();
      	$('.company-fields').slideUp();
       
       	cf.prop('required',true);
       
        company.prop('required',false);
        // cf_company.prop('required',false);
        piva.prop('required',false);
        pec.prop('required',false);
        sdi.prop('required',false);
       
      
   		
    } else if (user_type_value == 'Azienda'){
   
    	$('.enduser-fields').slideUp();
      	$('.company-fields').slideDown();
      
      	cf.prop('required',false);
       
        company.prop('required',true);
        // cf_company.prop('required',true);
        piva.prop('required',true);
        pec.prop('required',true);
        sdi.prop('required',true);
    } else {
        $('.enduser-fields').slideUp();
      	$('.company-fields').slideUp();
    
      	// cf_company.prop('required',false);
      	company.prop('required',false);
        piva.prop('required',false);
      	cf.prop('required',false);
        pec.prop('required',false);
        sdi.prop('required',false);
      
      	cf.val('');
        piva.val('');
        company.val('');
        cf_company.val('');
        sdi.val('');
        pec.val('');
    }
  }
});